<template>
  <div id="SearchDialog" ref="MainContent">
    <div class="dialog_box" data-dialog-box>
      <p class="title">搜尋商品</p>

      <div class="">
        <InputBox
          v-model="keyword"
          placeholder="請輸入商品關鍵字"
          error-message="請輸入商品關鍵字"
          :show-error-message="error"
        />
      </div>

      <div class="button_box">
        <button class="main_button dark" @click="Search">
          搜尋
          <span class="icon material-symbols-rounded"> search </span>
          <span class="bg_box"></span>
          <span class="shadow_box"></span>
        </button>
      </div>
    </div>

    <div
      @click="$emit('close-search-dialog')"
      class="background_box"
      data-dialog-background
    ></div>
  </div>
</template>

<script>
import { MainDialog } from "@/animations/mainDialog";
import InputBox from "@/components/form/InputBox.vue";
export default {
  name: "SearchDialog",
  components: {
    InputBox,
  },
  props: {
    dialog: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      animation: null,
      keyword: "",
      error: false,
    };
  },
  methods: {
    InitAnimation() {
      this.animation = new MainDialog(this.$refs.MainContent);
      this.animation.Reset();
    },
    Open() {
      this.animation.Open();
    },
    Close() {
      this.animation.Close();
      this.keyword = "";
    },
    Search() {
      this.error = false;
      if (this.keyword == "") {
        this.error = true;
        return;
      }
      this.$router.push("/collections?keyword=" + this.keyword);
      this.$emit("close-search-dialog");
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.Open();
      } else {
        this.Close();
      }
    },
  },
  mounted() {
    this.InitAnimation();
    if (this.dialog) {
      this.Open();
    }
  },
};
</script>
